export default class Page {
    constructor() {}

    updateImageDimensions($container: HTMLElement, imgSelector: string) {
        const images = $container.querySelectorAll<HTMLImageElement>(imgSelector);
        console.log(images);
        images.forEach($image => {
            console.log($image, $image.naturalWidth, $image.naturalHeight);
            if ($image.naturalWidth > $image.naturalHeight) {
                $image.style.height = 'calc(100% + 1px)';
                $image.style.width = 'auto';
                $image.style.maxHeight = 'unset';
            } else {
                $image.style.width = 'calc(100% + 1px)';
                $image.style.height = 'auto';
                $image.style.maxWidth = 'unset';
            }
        })

    }
}
